//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  //Путь до картинок, передаваемый через проп, должен учитывать, что в пути уже есть ~/assets/images/
  props: {
    imageSrc: {
      type: String,
      required: true,
    },
    retinaImageSrc: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    reversed: {
      type: Boolean,
      default: false,
    },
  },
};
